import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { ApiRequestService } from 'idt-ecommerce-api/_api/api-util/api-request.service';

import { ApiSeo } from './api-seo.models';


export interface ApiSeoServiceInterface {
  seo(languageId: string): Observable<ApiSeo>;
}

@Injectable()
export class ApiSeoService implements ApiSeoServiceInterface {

  constructor(private readonly http: HttpClient, private readonly requestService: ApiRequestService) {}

  public seo(languageId?: string): Observable<ApiSeo> {
    return this.requestService.requestUrl('web/seo/config', languageId).pipe(
      switchMap((url: string) => this.http.get<ApiSeo>(url))
    );
  }

}
